import script from "./HrPullToRefresh.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPullToRefresh.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPullToRefresh from 'quasar/src/components/pull-to-refresh/QPullToRefresh.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPullToRefresh});
